import { useEffect, useState } from 'react';

import { PageContainer, ScreenTwoPageLayout } from '~/components/Page/Page.Container';
import type { ScreenPropPausedSupportRequests } from '~/navigation/Navigation.types';

import { SupportRequestItem } from '../../SupportRequestItem';
import { VIRequestList } from './VirtualInventoryRequest.List';

export const VIRequestsClosedScreen = (props: ScreenPropPausedSupportRequests) => {
  return (
    <PageContainer>
      <VIRequestsClosedScreenLayout {...props} />
    </PageContainer>
  );
};

export const VIRequestsClosedScreenLayout = (props: ScreenPropPausedSupportRequests) => {
  const supportRequestId = props.route.params?.id;
  const [id, setId] = useState<string | undefined>(props.route.params?.id);

  useEffect(() => {
    setId(supportRequestId);
  }, [supportRequestId]);

  return (
    <ScreenTwoPageLayout>
      <VIRequestList onPress={(item) => setId(item.id)} id={id} />
      {id ? (
        <SupportRequestItem
          originScreen="VIRequestsClosed"
          supportId={id}
          onClose={() => setId(undefined)}
        />
      ) : (
        <></>
      )}
    </ScreenTwoPageLayout>
  );
};
